module.exports = __webpack_public_path__ + "img/topicGardeningDIY.5d91ed39.png";